import { Component } from '@angular/core';

@Component({
  selector: 'app-favorites-page-block',
  templateUrl: './favorites-page-block.component.html',
  standalone: false,
})
export class FavoritesPageBlockComponent {}
